import { getBackendUri } from '../utils/EnvConfigUtils';
import FetchUtils, { parseJSON } from './fetch_utils';

import {
	fetchBuyerAndSupplierUsers,
	fetchBuyerAndSupplierUsersSuccess,
	fetchBuyerAndSupplierUsersFailure,
} from '../actions/work_orders_subscribers_actions';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../actions/work_orders_actions';
import { logoutSuccess } from '../actions/session_actions';
import { nullSafeGetOrElse } from '../utils/DataAccessUtils';
import { CONTRACTOR_WO_SUBSCRIBER_ACTION_TO_ROUTE } from '../utils/DataConstants';

const fetchUtils = new FetchUtils();
const BASE_URL = getBackendUri();

export const fetchInternalSuppliersAndBuyerUsers =
	(search, userType, params = {}) =>
	() => {
		let fetchUsers = fetchBuyerAndSupplierUsers;
		let fetchUsersSuccess = fetchBuyerAndSupplierUsersSuccess;
		let fetchUsersFailure = fetchBuyerAndSupplierUsersFailure;

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(fetchUsers());

				fetchUtils
					.get(
						BASE_URL +
							`/api/v1/${userType}/common_contacts/buyer_internal_techs_active_contacts_list`,
						{ search, ...params }
					)
					.then((response) => response.json())
					.then((d) => {
						if (d.status === 'error') {
							dispatch(fetchUsersFailure([d.message]));
							reject(d.message);
						} else {
							const contacts = nullSafeGetOrElse('data', d, []).map((user) =>
								nullSafeGetOrElse('contactWithAccount', user, {})
							);
							dispatch(fetchUsersSuccess(contacts));
							resolve(contacts);
						}
					})
					.catch((d) => {
						dispatch(fetchUsersFailure(d.message));
						reject(d.message);
					});
			});
		};
	};

export const fetchAllUsersForBuyers =
	(search, woId, params = {}) =>
	() => {
		let fetchUsers = fetchBuyerAndSupplierUsers;
		let fetchUsersSuccess = fetchBuyerAndSupplierUsersSuccess;
		let fetchUsersFailure = fetchBuyerAndSupplierUsersFailure;

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(fetchUsers());

				fetchUtils
					.get(
						BASE_URL + `/api/v2/buyer/work_order/work_orders/subscribers/find_subscriber/${woId}`,
						{ search, ...params }
					)
					.then((response) => response.json())
					.then((d) => {
						if (d.status === 'error') {
							dispatch(fetchUsersFailure([d.message]));
							reject(d.message);
						} else {
							dispatch(fetchUsersSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(fetchUsersFailure(d.message));
						reject(d.message);
					});
			});
		};
	};
export const fetchAllUsersForSuppliers =
	(search, woId, params = {}) =>
	() => {
		let fetchUsers = fetchBuyerAndSupplierUsers;
		let fetchUsersSuccess = fetchBuyerAndSupplierUsersSuccess;
		let fetchUsersFailure = fetchBuyerAndSupplierUsersFailure;

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(fetchUsers());

				fetchUtils
					.get(
						BASE_URL +
							`/api/v2/supplier/work_order/work_orders/subscribers/find_subscriber/${woId}`,
						{ search, ...params }
					)
					.then((response) => response.json())
					.then((d) => {
						if (d.status === 'error') {
							dispatch(fetchUsersFailure([d.message]));
							reject(d.message);
						} else {
							dispatch(fetchUsersSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(fetchUsersFailure(d.message));
						reject(d.message);
					});
			});
		};
	};

export const fetchAllUsersForContractorWOSuppliers =
	(search, cwoId, params = {}) =>
	() => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(fetchBuyerAndSupplierUsers());

				fetchUtils
					.get(
						BASE_URL +
							`/api/v1/supplier/work_order/contractor_work_orders/subscribers/find_subscriber/${cwoId}`,
						{ search, ...params }
					)
					.then((response) => response.json())
					.then((d) => {
						if (d.status === 'error') {
							dispatch(fetchBuyerAndSupplierUsersFailure([d.message]));
							reject(d.message);
						} else {
							dispatch(fetchBuyerAndSupplierUsersSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(fetchBuyerAndSupplierUsersFailure(d.message));
						reject(d.message);
					});
			});
		};
	};

export const fetchAllContractorWOUsersForSuppliers =
	(search, woId, params = {}) =>
	() => {
		let fetchUsers = fetchBuyerAndSupplierUsers;
		let fetchUsersSuccess = fetchBuyerAndSupplierUsersSuccess;
		let fetchUsersFailure = fetchBuyerAndSupplierUsersFailure;

		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(fetchUsers());

				fetchUtils
					.get(
						BASE_URL +
							`/api/v1/supplier/work_order/contractor_work_orders/subscribers/find_subscriber/${woId}`,
						{ search, ...params }
					)
					.then((response) => response.json())
					.then((d) => {
						if (d.status === 'error') {
							dispatch(fetchUsersFailure([d.message]));
							reject(d.message);
						} else {
							dispatch(fetchUsersSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(fetchUsersFailure(d.message));
						reject(d.message);
					});
			});
		};
	};

//For a Buyer to add a subscriber who is a Buyer
export const addBuyerSubscribersForBuyers =
	(users, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(
						BASE_URL + `/api/v1/buyer/work_order/work_orders/subscribers/add_buyer_subscribers`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: users,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
//For a Buyer to add a subscriber who is a Supplier
export const addSupplierSubscribersForBuyers =
	(obj, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.post(
						BASE_URL + `/api/v1/buyer/work_order/work_orders/subscribers/add_supplier_subscribers`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: obj,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
//For a Supplier to add a subscriber who is a Buyer
export const addBuyerSubscribersForSuppliers =
	(users, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(
						BASE_URL + `/api/v1/supplier/work_order/work_orders/subscribers/add_buyer_subscribers`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: users,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};
//For a Supplier to add a subscriber who is a Supplier
export const addSupplierSubscribersForSuppliers =
	(obj, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.post(
						BASE_URL +
							`/api/v1/supplier/work_order/work_orders/subscribers/add_supplier_subscribers`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: obj,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

//**** Remove Subscribers Section ****

//Remove Buyer Subscribers for Buyer
export const removeBuyerSubscriberForBuyers =
	(obj, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.post(
						BASE_URL + `/api/v1/buyer/work_order/work_orders/subscribers/remove_buyer_subscribers`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: obj,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

//Remove Supplier Subscriber for Suppliers
export const removeSupplierSubscriberForBuyers =
	(obj, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.post(
						BASE_URL +
							`/api/v1/buyer/work_order/work_orders/subscribers/remove_supplier_subscribers`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: obj,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

//Remove Supplier Subscriber for Suppliers
export const removeSupplierSubscriberForSuppliers =
	(obj, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));
				fetchUtils
					.post(
						BASE_URL +
							`/api/v1/supplier/work_order/work_orders/subscribers/remove_supplier_subscribers`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: obj,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(d.data));
							resolve(d.data);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

const contractorSubscriberChanges =
	(userType, routeName) =>
	(users, params = {}) =>
	(entity) => {
		return (dispatch) => {
			return new Promise((resolve, reject) => {
				dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateStart(entity));

				fetchUtils
					.post(
						BASE_URL +
							`/api/v1/${userType}/work_order/contractor_work_orders/subscribers/${routeName}`,
						{
							headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
							data: users,
						}
					)
					.then(parseJSON)
					.then(({ json, status, ok }) => {
						const d = json;
						if (status === 401) {
							dispatch(logoutSuccess());
						}
						if (d.status === 'error') {
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
							reject(d.message);
						} else {
							const updatedEntity = {
								...entity,
								subContractedToWorkOrder: d.data,
							};
							dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateSuccess(updatedEntity));
							resolve(updatedEntity);
						}
					})
					.catch((d) => {
						dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.updateError(d.message, entity));
						reject(d.message);
					});
			});
		};
	};

export const addContractorSubscribers =
	(userType) =>
	(users, params = {}) =>
	(entity) =>
		contractorSubscriberChanges(userType, CONTRACTOR_WO_SUBSCRIBER_ACTION_TO_ROUTE.ADD_CONTRACTOR)(
			users,
			params
		)(entity);
export const removeContractorSubscribers =
	(userType) =>
	(users, params = {}) =>
	(entity) =>
		contractorSubscriberChanges(
			userType,
			CONTRACTOR_WO_SUBSCRIBER_ACTION_TO_ROUTE.REMOVE_CONTRACTOR
		)(
			users,
			params
		)(entity);
export const addSubSubscribers =
	(userType) =>
	(users, params = {}) =>
	(entity) =>
		contractorSubscriberChanges(userType, CONTRACTOR_WO_SUBSCRIBER_ACTION_TO_ROUTE.ADD_SUB)(
			users,
			params
		)(entity);
export const removeSubSubscribers =
	(userType) =>
	(users, params = {}) =>
	(entity) =>
		contractorSubscriberChanges(userType, CONTRACTOR_WO_SUBSCRIBER_ACTION_TO_ROUTE.REMOVE_SUB)(
			users,
			params
		)(entity);
